var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1937_4280)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.493164,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1937_4280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint1_radial_1937_4280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint2_radial_1937_4280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint3_radial_1937_4280)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1683 25.0225C18.6502 21.8819 21.441 19.4932 24.7862 19.4932C27.446 19.4932 29.7501 21.0008 30.8282 23.194C33.4042 23.2529 35.5001 25.2972 35.5001 27.8429C35.5001 30.4263 33.3419 32.4932 30.7138 32.4932C30.5679 32.4932 30.4232 32.4868 30.2801 32.4743H25.1319C25.0173 32.4799 24.9021 32.4828 24.7862 32.4828C24.6703 32.4828 24.5551 32.4799 24.4405 32.4743H18.4069C18.3826 32.4747 18.3583 32.4749 18.3339 32.4749C16.2319 32.4749 14.5001 30.8209 14.5001 28.747C14.5001 26.7277 16.1417 25.1066 18.1683 25.0225ZM24.7862 20.4932C21.7754 20.4932 19.3315 22.7437 19.1112 25.5691C19.1008 25.7015 19.0383 25.8243 18.9372 25.9105C18.8362 25.9967 18.705 26.0392 18.5726 26.0286C18.4939 26.0223 18.4143 26.019 18.3339 26.019C16.7535 26.019 15.5001 27.2554 15.5001 28.747C15.5001 30.2385 16.7535 31.4749 18.3339 31.4749C18.3535 31.4749 18.373 31.4747 18.3924 31.4744L18.4022 31.4742V31.4743H24.4531C24.4617 31.4743 24.4702 31.4745 24.4788 31.4749C24.5806 31.4802 24.6831 31.4828 24.7862 31.4828C24.8893 31.4828 24.9918 31.4802 25.0936 31.4749C25.1022 31.4745 25.1107 31.4743 25.1193 31.4743H30.3025C30.3178 31.4743 30.3332 31.475 30.3484 31.4764C30.4687 31.4875 30.5906 31.4932 30.7138 31.4932C32.8203 31.4932 34.5001 29.8438 34.5001 27.8429C34.5001 25.842 32.8203 24.1927 30.7138 24.1927C30.6529 24.1927 30.5923 24.1941 30.5321 24.1968C30.3238 24.2063 30.1315 24.0856 30.0496 23.8938C29.1992 21.9043 27.1684 20.4932 24.7862 20.4932Z",
    fill: "#88A9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1937_4280",
    x: -7.9,
    y: -7.40684,
    width: 65.8,
    height: 65.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1937_4280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1937_4280",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1937_4280",
    x1: -20,
    y1: -30.5369,
    x2: 75.8258,
    y2: 8.56886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1937_4280",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-26.6228 5.60829) rotate(35.1112) scale(57.6443 34.0523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1937_4280",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6381 33.9561) rotate(161.34) scale(41.7879 28.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1937_4280",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5444 -10.9342) rotate(47.2897) scale(27.9413 20.0791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud_icon.581ac5b2b78e850c170810fb739fd21f.svg";
export { ForwardRef as ReactComponent };